import React, { JSX } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material";
import { useAppDispatch } from "../../../store/hooks";
import { cancelBillingPackage } from "../../../slices/billPackageSlice";

interface Props {
  onCancel: () => void;
  open: boolean;
  id: number;
}

function BillingPackageCancel({ onCancel, open, id }: Props): JSX.Element {
  const dispatch = useAppDispatch();
  return (
    <Dialog fullWidth onClose={onCancel} open={open}>
      <DialogTitle>Cancel Package ?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary">
          Are you sure you want to cancel the package?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onCancel}>
          cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            dispatch(cancelBillingPackage(id));
            onCancel();
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default BillingPackageCancel;
